// Quality hub — folds the former QA Pulse + Bug Sources tabs together with the
// new velocity↔quality coupling (#2) under one "Quality" tab, switched by an
// internal sub-tab bar. Existing components are reused unchanged.

import { useState } from 'react'
import { PULSE_COLORS } from './pulseConfig.js'
import QualityVelocity from './QualityVelocity.jsx'
import PulseTab from './PulseTab.jsx'
import BugSources from './BugSources.jsx'

const SUBTABS = [
    { key: 'overview', label: 'Velocity vs Quality', icon: '📉' },
    { key: 'qa', label: 'QA Pulse', icon: '🩺' },
    { key: 'bugs', label: 'Bug Sources', icon: '🐞' },
]

export default function QualityHub({ selectedPod, refreshSignal }) {
    const [sub, setSub] = useState('overview')

    return (
        <div>
            <div
                style={{
                    display: 'inline-flex',
                    background: PULSE_COLORS.bgInner,
                    borderRadius: '10px',
                    border: `1px solid ${PULSE_COLORS.border}`,
                    overflow: 'hidden',
                    marginBottom: '20px',
                }}
            >
                {SUBTABS.map((t) => (
                    <button
                        key={t.key}
                        onClick={() => setSub(t.key)}
                        style={{
                            background: sub === t.key ? `${PULSE_COLORS.primary}25` : 'transparent',
                            border: 'none',
                            borderBottom: sub === t.key ? `2px solid ${PULSE_COLORS.primary}` : '2px solid transparent',
                            color: sub === t.key ? PULSE_COLORS.primary : PULSE_COLORS.textMuted,
                            padding: '8px 18px',
                            fontSize: '13px',
                            fontWeight: sub === t.key ? 700 : 400,
                            cursor: 'pointer',
                        }}
                    >
                        {t.icon} {t.label}
                    </button>
                ))}
            </div>

            {sub === 'overview' && <QualityVelocity refreshSignal={refreshSignal} />}
            {sub === 'qa' && <PulseTab selectedPod={selectedPod} refreshSignal={refreshSignal} />}
            {sub === 'bugs' && <BugSources />}
        </div>
    )
}
